<div class="modal-body form-modal-body">

  <div class="skylark-modal-header">
    <h4>Change Password</h4>
    <button type="button" class="icon" (click)="close()"><span class="pi pi-times"></span></button>
  </div>

  <div class="row">
    <div class="col-md-12">
      <form>
        <div class="menu-user__change-password_body">

          <div class="form-group">
            <label class="menu-user__change-password-label">Confirm Old Password</label>
            <input type="password" class="form-control" placeholder="Old Password" name="oldPassword"
              autocomplete="new-password" [(ngModel)]="oldPassword" (input)="validPasswordInput()"/>
          </div>

          <div class="form-group">
            <label class="menu-user__change-password-label">New Password</label>
            <input type="password" class="form-control" placeholder="New Password" name="password1"
              autocomplete="new-password" [(ngModel)]="password1" (input)="validPasswordInput()" />
          </div>

          <div class="form-group">
            <label class="menu-user__change-password-label">Repeat Password</label>
            <input type="password" class="form-control" placeholder="Repeat Password" name="password2"
              autocomplete="new-password" [(ngModel)]="password2" (input)="validPasswordInput()" />
          </div>

          <div class="mt-4">
            <button type="button" class="btn btn-round btn-block btn-success" [disabled]="isPasswordEmpty" (click)="submit()">Save</button>
          </div>

          <div>
            <div>
              <p-messages [(value)]="errorAlerts"></p-messages>
            </div>
            <div class="alert alert-warning" *ngIf="passwordErrorText.length" role="alert">
              <span *ngFor="let error of passwordErrorText"> {{ error }}<br /> </span>
            </div>
          </div>

        </div>

      </form>
    </div>


  </div>
</div>
